import { http } from './api.service';

export const ExportService = {
  getExportedDocUrl({ ext, type }, data) {
    http.defaults.timeout = 120000;
    return http.post(`/export/${ext}/${type}`, data);
  },
};
